import React from 'react';
import FavoriteSportModalWrapper from '~shared/components/favorite-sport-modal/FavoriteSportModalWrapper';
import { getOnBoardingPageEnabled, isUserLoggedIn } from '~shared/utils/user';

export const openOnboardingPageWithContext = (context) => {
    const { pushModal } = context || {};
    if (pushModal && isUserLoggedIn() && getOnBoardingPageEnabled()) {
        pushModal(<FavoriteSportModalWrapper />);
    }
};
